import { requestApi } from 'utils';

export const getBgmCompaniesApiRequest = () =>
  requestApi.query(`query getBgmCompaniesApiRequest{
  bgmCompanies {
    id
    name
  }
}`);
